<div class="inner">
  <div class="settings">
    <qai-call-button
      class="settings-button"
      [label]="('call.SETTINGS' | transloco)"
      kind="tertiary"
      icon="settings"
      (clicked)="handleSettingsClick()"
    />

    <qai-call-button
      class="captions-button"
      [label]="('call.CAPTIONS_LABEL' | transloco)"
      [kind]="isCaptionsOn ? 'tertiary' : 'destructive'"
      [icon]="isCaptionsOn ? 'captions' : 'captions-off'"
      (clicked)="handleCaptionsClick()"
    />
  </div>

  <div class="playback">
    <!-- Continue -->
    <div class="continue-button" *ngIf="showContinueButton">
      <ng-content select="[qaiSlot='continue']"></ng-content>
    </div>

    <!-- Vertical separator -->
    <div class="vertical-separator" *ngIf="showContinueButton && showPauseButton"></div>

    <!-- Timer -->
    <qai-call-timer
      class="timer"
      [class.timer-no-continue]="showPauseButton && !showContinueButton"
      [time]="time"
      [canPause]="false"
    />

    <!-- Vertical separator -->
    <div class="vertical-separator" *ngIf="!showContinueButton && showPauseButton"></div>

    <!-- Pause Button Small -->
    <qai-call-button
      class="pause-small-button"
      [class.pause-no-continue]="showPauseButton && !showContinueButton"
      [label]="('call.PAUSE_LABEL' | transloco)"
      [kind]="'tertiary'"
      [icon]="isPaused ? 'play' : 'pause'"
      *ngIf="showPauseButton"
      (clicked)="handlePlaybackClick()"
    />

    <!-- Pause Button Large -->
    <button
      class="pause-button"
      qai-button
      [shape]="'normal'"
      [kind]="'tertiary'"
      [size]="'medium'"
      [disabled]="!isPauseEnabled"
      *ngIf="showContinueButton && showPauseButton"
      (click)="handlePlaybackClick()"
    >
      <qai-icon
        [kind]="isPaused ? 'play-circle' : 'pause-circle'"
        positionStart
      />
      {{ isPaused ? ('call.RESUME' | transloco) : ('call.PAUSE_LABEL' | transloco) }}
    </button>

  </div>

  <div class="controls">
    <ng-content select="app-call-controls" />
  </div>
</div>
